export enum SurveyTypeEnum {
    NPS = '7b9321b6-b102-419d-b7ff-a804fc1f8b81'
}
